// extracted by mini-css-extract-plugin
module.exports = {"icon":"GlobalConfigUpdateForm_icon__3hl7T","listItem":"GlobalConfigUpdateForm_listItem__1L4y2"};